import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayersBehind: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayersBehind"><Path d="M4 3V4.5H20V3H4Z" fill="currentColor"/><Path d="M2 6V20H22V6H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayersBehind;
